<template>
  <div class="wrapBox">
    <div class="unifiedBox">
      <span class="title">{{ titleText }}</span>
      <van-loading color="#1989fa" />
    </div>
  </div>
</template>
<script>

import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
// import * as constant from '../../api/constant'
import { Toast, Dialog } from 'vant'
import axios from 'axios'

export default {
  data () {
    return {
      signParas: {},
      titleText: '努力加载中',
      haveCodeTitleText: '正在请求'
    }
  },
  created () {

  },
  mounted () {
    this.signParas = this.$route.query
    if (this.signParas.type === 'in') {
      this.signIn()
    } else {
      this.signOut()
    }
    // this.initJudgment()
  },
  computed: {
  },
  methods: {
    goLoginAndBack () {
      this.$router.push({
        path: '/login',
        query: {
          page: 'sign_in_out',
          ...this.$route.query
        },
        replace: true
      })
    },
    // 进行签到
    async signIn () {
      const loading = Toast.loading({
        message: '签到中...',
        forbidClick: true
      })
      const pubPara = api.getPublicPara()
      const para = {
        ...pubPara,
        room_id: this.signParas.room_id || this.signParas.roomId,
        timestamp: this.signParas.t,
        book_id: (this.signParas.book_id || this.signParas.bookId) || -1
      }
      try {
        const positionInfo = await utils.getCurrentPosition()
        if (positionInfo.browserSupport && positionInfo.phoneSignInFlag) {
          para.longitude = positionInfo.currentLongitude
          para.latitude = positionInfo.currentLatitude
          para.geolocation = positionInfo.geolocation
        }
      } catch (e) {
        let msg
        if (e && e.code === 1) {
          msg = '无法开启位置信息授权'
        }
        return Toast({
          type: 'fail',
          duration: 3000,
          message: msg || e.message,
          onClose: () => {
            this.$router.replace('/order')
          }
        })
      }
      axios({
        method: 'post',
        // url: common.baseUrl + '/api/' + api.urlList.signIn,
        url: common.baseUrl + '/api/piano.up',
        data: para
      }).then((response) => {
        if (response.status >= 200 && response.status < 300) {
          const res = response.data
          if (res.code === common.resCode.OK) {
            this.$router.replace('/signInOk')
          } else if (res.code === common.resCode.Unauthorized) {
            this.goLoginAndBack()
          } else {
            Dialog.alert({
              title: '提示',
              message: res.msg
            }).then(() => {
              // on confirm
              this.$router.replace('/order')
            })
          }
        }
      }).catch((e) => {
        console.log('error log:', e)
        this.$router.replace('/order')
      }).finally(() => {
        loading.close()
      })
    },
    // 进行签退
    async signOut () {
      const loading = Toast.loading({
        message: '签退中...',
        forbidClick: true
      })
      const pubPara = api.getPublicPara()
      const para = {
        ...pubPara,
        room_id: this.signParas.room_id || this.signParas.roomId,
        timestamp: this.signParas.t,
        book_id: (this.signParas.book_id || this.signParas.bookId) || -1
      }
      try {
        const positionInfo = await utils.getCurrentPosition()
        if (positionInfo.browserSupport && positionInfo.phoneSignInFlag) {
          para.longitude = positionInfo.currentLongitude
          para.latitude = positionInfo.currentLatitude
          para.geolocation = positionInfo.geolocation
        }
      } catch (e) {
        let msg
        if (e && e.code === 1) {
          msg = '无法开启位置信息授权'
        }
        return Toast({
          type: 'fail',
          duration: 3000,
          message: msg || e.message,
          onClose: () => {
            this.$router.replace('/order')
          }
        })
      }
      axios({
        method: 'post',
        // url: common.baseUrl + '/api/' + api.urlList.signOut,
        url: common.baseUrl + '/api/piano.qr_down',
        data: para
      }).then((response) => {
        Toast.clear()
        if (response.status >= 200 && response.status < 300) {
          const res = response.data
          if (res.code === common.resCode.OK) {
            this.$router.replace('/signOutOk')
          } else if (res.code === common.resCode.Unauthorized) {
            this.goLoginAndBack()
          } else {
            Dialog.alert({
              title: '提示',
              message: res.msg
            }).then(() => {
              // on confirm
              this.$router.replace('/order')
            })
          }
        }
      }).catch((e) => {
        console.log('error log:', e)
        loading.close()
        this.$router.replace('/order')
      })
    }
  }
}
</script>
<style scoped lang="scss">
.wrapBox {
  height: 100%;
  .unifiedBox {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      font-size: 1rem;
      line-height: 1.875rem;
    }
  }
}
</style>
